import { Component } from '@angular/core';
import { GlobalService, JwtService } from 'src/app/services/index.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  readonly envoirement = environment 
  constructor(
    public global:GlobalService,
  ){}

  enamadShow(){
    return this.envoirement.production && this.envoirement.mode.prod
  }
}
